import {
  FormControl,
  FormLabel,
  Select,
  SelectProps,
  styled,
} from "@mui/material";

interface Props extends SelectProps {
  customLabel: string;
}

export function FilterSectionSelection(props: Props) {
  const { customLabel, children, ...selectProps } = props;
  return (
    <StyledFormControl fullWidth>
      <FormLabel>{customLabel}</FormLabel>
      <Select {...selectProps}>{children}</Select>
    </StyledFormControl>
  );
}

const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    text-transform: uppercase;
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
`;
